import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditOwnVehicleModal = ({ isOpen, onClose, editFormData, setEditFormData }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

 const handleEditSubmit = async (e) => {
  e.preventDefault();

  // 🔹 Validation for Vehicle Name
  if (!editFormData.vName || editFormData.vName.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Vehicle Name!",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      `https://rfs2.infraconsoft.net.in/api/own_veh_edit/${editFormData.id}`,
      {
        vCode: editFormData.vCode,
        vName: editFormData.vName,
      }
    );

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Own Vehicle Name updated successfully.",
      });
      onClose();
      window.location.reload();
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "This Serial No already Exist. Please try Different One.",
      });
    }
  } catch (error) {
    console.error("Error updating category:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Update failed. Please try again.",
    });
  }
};

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onClose} style={{position: "initial"}}>&times;</button>
    </div>
        <h3>Edit Own Vehicle Name</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="deptCode" value={editFormData.vCode} onChange={handleEditChange} readOnly/>
              </div>
             
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Name :</label>
                <input
            type="text"
            name="vName"
            value={editFormData.vName}
            onChange={handleEditChange}
          />
              </div>
              
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditOwnVehicleModal;
